<template>
  <div id="app">
		<!-- <router-link> 默认会被渲染成一个 `<a>` 标签 -->
   <!-- <router-link to="/start">开始</router-link>

   <router-link to="/home">点餐</router-link>

   <router-link to="/cart">购物车</router-link> -->

   <!-- 路由出口 -->
  <!-- 路由匹配到的组件将渲染在这里 -->
    <router-view></router-view>
  </div>
</template>

<script>

import './assets/css/basic.scss';
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue